<template>
  <div class="content">
    <div class="item" @click="toOrderDetail">
      <div class="item-con">
        <span class="title">订单编号</span>
        <span class="id">187287636638387</span>
        <span class="right"><img :src="public_path + '/static/images/arrow_right.svg'" alt=""></span>
      </div>
      <div class="item-con">
        <span class="sum">￥799</span>
        <span class="status">待支付</span>
        <span class="time">2018/06/24 15:40:19</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH
    }
  },
  methods: {
    toOrderDetail () {
      this.$router.push({
        path: '/orderdetail'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  font-size: 0;
  color: #333;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
  overflow-y: auto;
  -webkit-overflow-scrolling:touch;
  .item {
    padding: .4rem .3rem;
    background: #fff;
    border-bottom: 1px solid #ebebeb;
    .item-con {
      display: -webkit-flex;
      align-items: center;
      font-size: .3rem;
      & + .item-con {
        margin-top: .36rem;
      }
      .title {
        flex: 1;
      }
      .id {
        flex: 2;
        color: rgba(51, 51, 51, .5);
      }
      .right {
        flex: 1;
        text-align: right;
        img {
          width: .14rem;
          height: .25rem;
          float: right;
        }
      }
      .sum {
        flex: 1;
        color: #FD5A41;
      }
      .status {
        width: .86rem;
        height: .34rem;
        line-height: .34rem;
        border-radius: .06rem;
        border:2px solid rgba(253, 90, 65, 1);
        color: #FD5A41;
        font-size: .26rem;
        text-align: center;
      }
      .time {
        text-align: right;
        flex: 2;
        color: rgba(51, 51, 51, .5);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/buyhistory/Buyhistory.vue